// extracted by mini-css-extract-plugin
export default {"container":"NewsHeader_container__o1wC0","separator":"NewsHeader_separator__tFD2l","author":"NewsHeader_author__cENaR"};